import { useState } from 'react';
import { useTheme } from '../../ThemeContext';

export default function Button({
  children,
  onClick,
  type = 'button',
  variant = 'primary',
  disabled = false,
  fullWidth = false,
  lift = false,
  style: styleProp = {},
  ...rest
}) {
  const { t } = useTheme();
  const [hovered, setHovered] = useState(false);

  const baseStyle = {
    fontSize: variant === 'primary' ? '15px' : '14px',
    fontWeight: variant === 'primary' ? '600' : '500',
    fontFamily: 'Poppins, sans-serif',
    padding: '12px 20px',
    border: 'none',
    borderRadius: variant === 'primary' ? '12px' : '6px',
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    transition: 'all 0.2s',
    ...(fullWidth ? { width: '100%' } : {}),
  };

  const variantStyle = variant === 'primary'
    ? {
        backgroundColor: t.buttonBg,
        color: t.buttonText,
      }
    : {
        backgroundColor: 'transparent',
        color: t.buttonSecondaryText || t.text,
        border: `1px solid ${t.buttonSecondaryBorder || t.borderStrong}`,
      };

  const hoverStyle = lift && hovered && !disabled
    ? { transform: 'translateY(-2px)', opacity: 0.9 }
    : {};

  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      style={{
        ...baseStyle,
        ...variantStyle,
        ...hoverStyle,
        ...styleProp,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      {...rest}
    >
      {children}
    </button>
  );
}
